<template>
  <div class="content-block dx-card responsive-paddings">
    <h3>Setup Your Device (id:{{siteInfo.id}})</h3>  
    <p>Please fill the information below to setup your device for the first time</p>
    <form @submit.prevent="configDevClick">
      <DxForm :form-data="siteInfo" :col-count="3" :min-col-width="200" :show-validation-summary="true"> 
        <DxSimpleItem data-field="deviceName" :col-span="3" :is-required="true" ><DxLabel text="Device name" /></DxSimpleItem>
        <DxSimpleItem data-field="description" :col-span="3" editor-type="dxTextArea" ><DxLabel text="Device description" /></DxSimpleItem>
        <DxSimpleItem data-field="companyName" :col-span="3" :is-required="true" ><DxLabel text="Company Name" /></DxSimpleItem>
        <DxSimpleItem data-field="locationAddr" :col-span="2" :is-required="false" ><DxLabel text="Company Location" /></DxSimpleItem>
        <DxSimpleItem data-field="country_name" :is-required="true" editor-type="dxSelectBox" :editor-options="{ searchEnabled: true, dataSource: countriesDataSource, valueExpr: 'name', displayExpr: 'name'}" ><DxLabel text="Location Country" /></DxSimpleItem>
        <DxButtonItem :col-span="1" :button-options="{ text: 'Save Changes', type:'success', preventDefault: true, useSubmitBehavior: true}"/>
      </DxForm>
    </form>
    <p>*To edit the location, use the map below to move the marker into your desired location and click update, then save the changes</p>
    <div v-if="isConfiguring" class="setup-progress">
      <div class="progress-info" >
        {{ actionName(currentAction) }}
      </div>
      <DxProgressBar
        id="progress-bar-status"
        :class="{complete: currentAction == 4 }"
        :min="0"
        :max="100"
        :status-format="statusFormat"
        :value="actionPerctg(currentAction)"
        width="90%"
      />
    </div>
  </div>
</template>
<script>
import RawDataService from '../services/RawDataServiceTemplate';
import { DxForm, DxSimpleItem, DxButtonItem, DxLabel } from 'devextreme-vue/form';
import { DxProgressBar } from 'devextreme-vue/progress-bar';
//import notify from 'devextreme/ui/notify';
import { reactive, ref } from 'vue';

export default {
  components: {
    DxForm, 
    DxSimpleItem, 
    DxButtonItem, 
    DxLabel,
    DxProgressBar,
  },
  setup() {
    const siteInfo = reactive({ deviceName: null });
    const isConfiguring = ref(false);
    const configStatus = reactive({ 
      orgCreation: false,
      userConfig: false,
      siteConfig: false,
      iotConfig: false,
      deviceConfig: false,
      });
    const countriesDataSource = ref([{name: 'Spain', alpha2Code: 'ES'}]);
    const setupActions = [
      { id: 0, name: 'Preparing data', pctg: 0 },
      { id: 1, name: 'Creating objects', pctg: 10 },
      { id: 2, name: 'Configuring site parameters', pctg: 60 },
      { id: 3, name: 'Configuring device parameters', pctg: 90 },
      { id: 4, name: 'Finished', pctg: 100 },
    ]

    // let orgDataService = new RawDataService('orgs/device');
    let countriesDataService = new RawDataService('masters/countries');
    countriesDataService.getAll()
      .then( (data) => { countriesDataSource.value = data; })
      .catch( error => { console.log(error) })
    // orgDataService.getAll()
    //   .then( org => { console.log(org) })
    //   .catch( error => { notify(error.message||"error loading address", "error", 3000);} );

    const configDevClick = () => {
      isConfiguring.value=true;
      console.log('test!!')
    }
    const statusFormat = (value) => {
      return `Loading: ${ value * 100 }%`;
    }
    const actionName = (value) => {
      return setupActions[value].name;
    };
    const actionPerctg = (value) => {
      return setupActions[value].pctg;
    };
    const currentAction = ref(4);
    
    return {
      countriesDataSource,
      siteInfo,
      isConfiguring,
      configStatus,

      actionName, 
      actionPerctg,
      currentAction,

      configDevClick,
      statusFormat,
    }
  },
}
</script>
<style lang="scss">

.setup-progress {
  padding: 20% 0;
  text-align: center;
}

#progress-bar-status {
  display: inline-block;
}

.complete .dx-progressbar-range {
  background-color: green;
}
</style>
